import { createTestIds } from '@duke-hq/lib';

export const testIds = createTestIds('apps-provider-web-tenant-Enrolments', [
  'Header',
  'TableHeading',
]);
